import React from "react";

const dores = [
  {
    titulo: "Tempo que vai para o controle",
    texto: "Horas da equipe gastas conferindo, repetindo e consolidando informação que um sistema feito para a operação registraria sozinho.",
  },
  {
    titulo: "Decisão sem o dado na mão",
    texto: "Quando o número certo demora para aparecer, a decisão espera ou é tomada no escuro.",
  },
  {
    titulo: "Crescimento que não cabe no processo",
    texto: "O que funcionava com dez pedidos por dia vira gargalo com cem. Um sistema sob medida cresce junto com a empresa.",
  },
];

const Problem = () => {
  return (
    <div id="sem-sistema">
      <div className="bg-storm text-white">
        <div className="w-3/4 mx-auto xl:pt-64 pt-40 xl:pb-32 pb-16">
          <p className="text-sm font-semibold uppercase tracking-widest text-white/70 mb-4 xl:text-center">O ponto de partida</p>
          <h2 className="text-3xl xl:text-5xl font-semibold xl:text-center mb-6">
            Quando a operação não tem um software feito para ela
          </h2>
          <p className="text-lg xl:text-xl leading-relaxed text-white/75 xl:text-center xl:w-2/3 xl:mx-auto mb-12 xl:mb-20">
            É assim que a maioria dos clientes chegam até a Hawx. Três sinais de que chegou a hora de ter o seu:
          </p>
          <ul className="grid grid-cols-1 md:grid-cols-3 gap-10 xl:gap-16">
            {dores.map((dor) => (
              <li key={dor.titulo} className="border-t-2 border-white/30 pt-6">
                <h3 className="text-xl xl:text-2xl font-semibold mb-3">{dor.titulo}</h3>
                <p className="text-lg leading-relaxed text-white/75">{dor.texto}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Problem;
